import { Component } from '@angular/core';

import { CouponsPage } from '../coupons/coupons';
import { CartPage } from '../cart/cart';
import { MenuPage } from '../menu/menu';
import { ProfilePage } from '../profile/profile';
import { SettingsPage } from '../settings/settings';
import {CartService} from "../../app/services/cart.service";
import {Cart} from "../../app/classes/cart";
import {MODULES} from "../../app/constants/config";

@Component({
  templateUrl: 'tabs.html',
  providers: [CartService]
})
export class TabsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  public showCoupons = false
  public showAlways = true;
  tab1Root: any = MenuPage;
  tab2Root: any = CartPage;
  tab3Root: any = CouponsPage;
  tab4Root: any = ProfilePage;
  tab5Root: any = SettingsPage;
  public cart : Cart;
  constructor(public cartService : CartService) {
    this.cart = cartService.getCart();
    this.showCoupons = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts